import React from "react";
import "./Select.css";

const Select = ({ label, value, onChange, options }) => {
  return (
    <label className="esim-select-label">
      {label && <span className="esim-select-label-text">{label}</span>}
      <div className="esim-select-wrapper">
        <select className="esim-select" value={value} onChange={(e) => onChange(e.target.value)}>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </label>
  );
};

export default Select;
